// Icelandic kennitala (national ID for people and companies): 10 digits, DDMMYY-RRCK,
// where C is a mod-11 check digit and K the century (9 = 1900s, 0 = 2000s).
// Companies add 4 to the first digit of the day. Shared by the admin form and the API.

const WEIGHTS = [3, 2, 7, 6, 5, 4, 3, 2];

/** Digits only, e.g. "010190-2939" -> "0101902939". */
export const cleanKennitala = (v) => String(v || '').replace(/[\s-]/g, '');

export const isValidKennitala = (v) => {
    const kt = cleanKennitala(v);
    if (!/^\d{10}$/.test(kt)) return false;
    const sum = WEIGHTS.reduce((s, w, i) => s + w * Number(kt[i]), 0);
    const r = sum % 11;
    const check = r === 0 ? 0 : 11 - r;
    if (check === 10 || check !== Number(kt[8])) return false;
    const day = Number(kt.slice(0, 2)) % 40;
    const month = Number(kt.slice(2, 4));
    return day >= 1 && day <= 31 && month >= 1 && month <= 12 && ['8', '9', '0'].includes(kt[9]);
};

export const formatKennitala = (v) => {
    const kt = cleanKennitala(v);
    return kt.length === 10 ? `${kt.slice(0, 6)}-${kt.slice(6)}` : kt;
};

/** "010190-****" for the public payment page. */
export const maskKennitala = (v) => `${cleanKennitala(v).slice(0, 6)}-****`;

/** Company kennitala: the day starts with 4–7. */
export const isCompanyKennitala = (v) => Number(cleanKennitala(v)[0]) >= 4;
